export default __webpack_public_path__ + "static/media/typeGame.d3386e38.png";